import type { ISelection } from "@/_store/selector.module";

/**
 * Transforms an ISelection of objects into an ISelection of strings
 * by extracting a specific string-typed key from each item.
 * @pure
 * @param selection - The ISelection to transform
 * @param key - The string-typed key to extract from each item
 * @returns ISelection<string> with include/exclude arrays as string arrays
 */
export const getSelectionAsStringsArray = <T extends object>(
  selection: ISelection<T>,
  key: keyof { [P in keyof T as T[P] extends string ? P : never]: T[P] }
): ISelection<string> => {
  return {
    isAllPages: selection.isAllPages,
    include: selection.include.map((item) => item[key] as string),
    exclude: selection.exclude.map((item) => item[key] as string),
  };
};
